import { create } from 'zustand';

type AppStore = {
  isLoggingOut: boolean;
  setIsLoggingOut: () => void;
};

export const useAppStore = create<AppStore>()((set) => ({
  isLoggingOut: false,
  setIsLoggingOut: () => set({ isLoggingOut: true }),
}));
